
import React from 'react';
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
const ContactSection = () => {
  return <section id="contact" className="py-20 px-6 bg-secondary">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-dark">Vereinbare ein kostenloses Beratungsgespräch</h2>
          <p className="text-grey text-lg max-w-3xl mx-auto">Erfahre in einer Demo, wie du ChatGPT-Power auf deiner eigenen Infrastruktur nutzen kannst und starte mit uns in deine KI-Zukunft!</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Card 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-custom flex flex-col">
            <div className="flex items-center gap-4 mb-6">
              <img src="/assets/images/andreas_koop.webp" alt="Andreas Koop" className="w-20 h-20 rounded-full object-cover" />
              <div>
                <h3 className="text-xl font-bold text-dark">Andreas Koop</h3>
                <p className="text-grey">Geschäftsführung</p>
                <a href="https://enpit.de" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline text-sm">
                  enpit GmbH & Co. KG
                </a>
              </div>
            </div>
            
            <div className="flex-grow">
              <p className="text-grey mb-6">
                Spezialisiert auf KI-Lösungen für den Mittelstand mit über 10 Jahren Erfahrung 
                in der Entwicklung innovativer IT-Konzepte.
              </p>
            </div>
            
            <Button asChild className="w-full bg-primary hover:bg-primary/90 text-white flex items-center gap-2">
              <a href="https://calendly.com/andreaskoop/contact" target="_blank" rel="noopener noreferrer">
                <Calendar size={18} />
                <span>Beratungstermin mit Andreas buchen</span>
              </a>
            </Button>
          </div>
          
          {/* Contact Card 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-custom flex flex-col">
            <div className="flex items-center gap-4 mb-6">
              <img src="/assets/images/aleksander_fegel.jpg" alt="Aleksander Fegel" className="w-20 h-20 rounded-full object-cover" />
              <div>
                <h3 className="text-xl font-bold text-dark">Aleksander Fegel</h3>
                <p className="text-grey">Geschäftsführung</p>
                <a href="https://ailio.de" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline text-sm">
                  ailio GmbH
                </a>
              </div>
            </div>
            
            <div className="flex-grow">
              <p className="text-grey mb-6">
                Experte für die Integration von KI-Systemen in Unternehmensprozesse und 
                maßgeschneiderte Lösungen für mittelständische Betriebe.
              </p>
            </div>
            
            <Button asChild className="w-full bg-primary hover:bg-primary/90 text-white flex items-center gap-2">
              <a href="https://calendly.com/afegel/30min" target="_blank" rel="noopener noreferrer">
                <Calendar size={18} />
                <span>Beratungstermin mit Aleksander buchen</span>
              </a>
            </Button>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <p className="inline-block bg-white px-6 py-3 rounded-full text-sm font-medium text-grey border border-gray-200">
            Alle Daten bleiben zu 100% auf deinen Servern – volle Kontrolle, maximale Sicherheit
          </p>
        </div>
      </div>
    </section>;
};
export default ContactSection;
